import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './GDTableAssignmentSummary.scss';
import PrimaryButton from 'Components/Button/PrimaryButton';
import attachFailureLogo from 'Assets/img/attachFailure.svg';
import attachSuccessLogo from 'Assets/img/attachSuccess.svg';
import spinningLogo from 'Assets/img/spinning.svg';

import SelectInput from 'Components/forms/select-input/SelectInput';

class GDTableAssignmentSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            removeAssigned: false,
        };
        this.attachBindings();
    }

    attachBindings() {
        this.removeAssignment = this.removeAssignment.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
    }

    removeAssignment(index) {
        this.props.summaryData.map((filter) => {
            if (index == filter.index) {
                filter.clear = true;
                filter.isAttachSuccess = null;
                filter.documentLabel = null;
                filter.assignedLabelValidate = false;
                this.setState({ removeAssigned: !this.state.removeAssigned });
                this.setState({ [`${index}`]: ''});
            }
        });
        this.props.updatedSummaryData(this.props.summaryData);
    }

    handleSelection = (caseRowId) => (e) => {
        const selectedOption = this.props.documentTypes.find((item) => item.value === e);
        if (selectedOption) {
            this.setState({
                [`${caseRowId}`]: selectedOption,
            });
        }
        this.props.summaryData.map((filter) => {
            if (caseRowId == filter.index) {
                filter.documentLabel = selectedOption.value;
                filter.assignedLabelValidate = false;
                filter.isAttachSuccess = null;
            }
        });
    }

    render() {
        let summaryRowIndex = 0;
        let topTwoRows = 0;
        console.log("first",this.props.summaryData,this.props.documentTypes)
        return (
            <div className="image-search-panel">
                <div className="gd-table__main-container" style={{ overflowY: 'auto', height: '140px', }}>
                    <ul className="panel-container action-panel">
                        {this.props.summaryPanel !== undefined && this.props.summaryPanel.length > 0 && this.props.summaryPanel.map((label) => {
                            return (
                                label.displayType == "summary" && <div className="wrapper-summary">
                                    <li key={label.id}>
                                        {label.name == 'Case Number'
                                            ? <span className="item-label_img">{label.name}</span>
                                            : label.name == 'Pages'
                                                ? <span className="item-label_img2">{label.name}</span>
                                                : label.name == 'Assign Label'
                                                    ? <span className="item-label_img3">{label.name}</span>
                                                    : <span className="item-label_img4">{label.name}</span>
                                        }
                                    </li>
                                </div>
                            );
                        })
                        }
                        {this.props.summaryData.map((caseRow, index) => {
                            summaryRowIndex = summaryRowIndex + 1;
                            if (caseRow.clear == false && topTwoRows < 2) {
                                topTwoRows = topTwoRows + 1;
                                caseRow.firstTwoRow = true;
                            } else {
                                caseRow.firstTwoRow = false;
                            }

                            return (
                                caseRow.clear == false &&
                                <div className="wrapper-summary2">
                                    <li key={caseRow.id}>
                                        <span className="assing-value">{caseRow.caseNbr}</span>
                                        <div className="wrapper-summary-panel">
                                            <div className="wrapper-summary5">
                                                {caseRow.pages.map((page, index) => {

                                                    return (

                                                        <span key={page.id} className="assing-value">{page.pageId + 1}{index < caseRow.pages.length - 1 && `,`}&nbsp;</span>
                                                    );
                                                })
                                                }
                                            </div>
                                        </div>
                                        <div className="wrapper-summary-panel">
                                            <div className="wrapper-summary3 error-asterik">
                                                <span key={caseRow.id}>
                                                    {
                                                        this.props.documentTypes.length == 1 ?
                                                            this.props.summaryData.map((element) => {
                                                                if (caseRow.index == element.index) {
                                                                    element.assignedLabelValidate = false;
                                                                    element.documentLabel = this.props.documentTypes[0].value;
                                                                }
                                                            }) : ''
                                                    }
                                                    <div className="item-dropdown">
                                                        <SelectInput
                                                            doclabelClass={"doclabel-list"}
                                                            queueType={this.props.type}
                                                            promptText={this.props.documentTypes.length > 1 ? 'Select Document Label' : this.props.documentTypes[0].text}
                                                            id={caseRow.index}
                                                            extraClass={caseRow.assignedLabelValidate ? "error-border" : ""}
                                                            classExtension={"doclabel-dropdown"}
                                                            dataList={this.props.documentTypes.length > 1 ? this.props.documentTypes : []}
                                                            selectClass={{
                                                                listStyleType: 'none',
                                                                padding: '0',
                                                                color: '#0F7DC4',
                                                                top: caseRow.firstTwoRow == true ? '' : 'unset',
                                                                bottom: caseRow.firstTwoRow == true ? '' : '100%',
                                                            }}
                                                            elementStyle={{
                                                                width: '160px',
                                                                fontWeight: 400,
                                                                fontSize: 10,
                                                                marginLeft: '-13px',
                                                            }}
                                                            handleSelection={this.handleSelection(caseRow.index)}
                                                            selectedItem={this.state[caseRow.index]}
                                                            wrapperClass="select-menu__form reports field-input"
                                                            isDisabled={this.props.documentTypes.length > 1 ? false : true}
                                                        />
                                                        {
                                                            (caseRow.assignedLabelValidate && (caseRow.documentLabel == '' || caseRow.documentLabel == undefined)) &&
                                                            <div className="error-msg">Document Label is required.</div>
                                                        }
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="wrapper-summary-panel">
                                            <div className="wrapper-summary6">
                                                {caseRow.spiningLogo ?
                                                    <img
                                                        src={spinningLogo}
                                                        alt="spinning Logo"
                                                        className="spin-logo"
                                                    /> :
                                                    caseRow.isAttachSuccess == true ? '' : <span key={caseRow.id} className="item-clear" onClick={() => this.removeAssignment(caseRow.index)}>Clear &nbsp;&nbsp;</span>
                                                }
                                                {caseRow.isAttachSuccess == true &&
                                                    <img
                                                        src={attachSuccessLogo}
                                                        alt="succes attached"
                                                        className="attach-logo"
                                                    />}
                                                {caseRow.isAttachSuccess == false &&
                                                    <img
                                                        src={attachFailureLogo}
                                                        alt="failure attached"
                                                        className="failure-attach-logo"
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </li>
                                </div>
                            );
                        })}
                    </ul>
                </div>
                <ul className="panel-container end-panel2" >
                    { //<li className="locked-user-visible custom-wrapper locked-wrapper"></li>
                    }
                    <li className="custom-wrapper action-wrapper">
                        <div className="attachbtn">
                            <PrimaryButton
                                action={() => { this.props.attachAndArchive(this.props.summaryData) }}
                                id={'active'}
                                disabled={null}>
                                <label className="assingLabel">Attach {'&'} Archive</label>
                            </PrimaryButton>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}
GDTableAssignmentSummary.propTypes = {
    summaryPanel: PropTypes.array.isRequired,
    summaryContent: PropTypes.array,

};

export default GDTableAssignmentSummary;